// extracted by mini-css-extract-plugin
export default {"fundsCard":"fundsCard-18wtR","tableWrapper":"tableWrapper-1qH5z","table":"table-3zNBV"};